import { useState } from "react";

import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

const filter = createFilterOptions();

export default function AutocompleteAdd(props) {
  const [value, setValue] = useState(null);
  let acVal = {};

  return (
    <Autocomplete
      className={props.className}
      //value={value}
      value={props.val}
      onChange={(evt, newValue) => {
        if (typeof newValue === "string") {
          // setValue({
          //   title: newValue,
          // });
          acVal = {
            title: newValue,
          };
        } else if (newValue && newValue.inputValue) {
          // Create a new value from the user input
          // setValue({
          //   title: newValue.inputValue,
          // });
          acVal = {
            title: newValue.inputValue,
          };
        } else {
          // setValue(newValue);
          acVal = newValue;
        }
        // setValue(acVal);
        console.log("ac =", props.name, acVal);
        props.onChg(props.name, acVal.title);
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some(
          (option) => inputValue === option.title
        );
        if (inputValue !== "" && !isExisting) {
          filtered.push({
            inputValue,
            title: `Add "${inputValue}"`,
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id="free-solo-with-text-demo"
      options={props.data}
      getOptionLabel={(option) => {
        // console.log(typeof option, option);

        // Value selected with enter, right from the input
        if (typeof option === "string") {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.title;
      }}
      renderOption={(props, option) => <li {...props}>{option.title}</li>}
      // sx={{ maxWidth: 600 }}
      // size="small"
      freeSolo
      renderInput={(params) => <TextField {...params} label={props.label} />}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
// const top100Films = [
//   { title: "The Shawshank Redemption", year: 1994 },
//   { title: "The Godfather", year: 1972 },
//   { title: "The Godfather: Part II", year: 1974 },
//   { title: "The Dark Knight", year: 2008 },
//   { title: "12 Angry Men", year: 1957 },
//   { title: "Schindler's List", year: 1993 },
//   { title: "Pulp Fiction", year: 1994 },
//   {
//     title: "The Lord of the Rings: The Return of the King",
//     year: 2003,
//   },
// ];
